module.exports = __webpack_public_path__ + "img/DE03743.cb50b6ec.png";